module.exports = __webpack_public_path__ + "static/media/bin.053157da.svg";